import type { ProbationQuestion } from "../schemas/index.ts";

export const SQE_INDUCTION_QUESTION_ID = 25;

export function isInductionYes(answer: unknown): boolean {
  return typeof answer === "string" && answer.trim().toLowerCase() === "yes";
}

export function isSqeInductionDurationQuestion(question: ProbationQuestion): boolean {
  return /\bif yes,\s*please specify the duration\b/i.test(question.question.trim());
}

export function sqeEmployeeQuestions(questions: ProbationQuestion[]): ProbationQuestion[] {
  const inductionQuestion = questions.find((question) => question.questionId === SQE_INDUCTION_QUESTION_ID);
  const certificationIndex = questions.findIndex((question) => question.questionId === 24);
  const durationQuestion = questions.find(isSqeInductionDurationQuestion);
  const remainingQuestions = questions.filter(
    (question) => question.questionId !== 24
      && question.questionId !== SQE_INDUCTION_QUESTION_ID
      && question !== durationQuestion,
  );

  if (!inductionQuestion) return remainingQuestions;

  const insertionIndex = certificationIndex >= 0
    ? questions.slice(0, certificationIndex).filter((question) => question.questionId !== SQE_INDUCTION_QUESTION_ID).length
    : Math.min(5, remainingQuestions.length);
  remainingQuestions.splice(insertionIndex, 0, inductionQuestion);
  if (durationQuestion) remainingQuestions.splice(insertionIndex + 1, 0, durationQuestion);
  return remainingQuestions;
}
